import { connect } from 'react-redux';
import ModalFreeEventRegistration from './ModalFreeEventRegistration';
import { RootState } from 'store/types';

const mapStateToProps = (state: RootState) => ({
  guest: state.event.guests.items[0],
});

export default connect(mapStateToProps, {})(ModalFreeEventRegistration);
